import { UI, HStack, VStack } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import { Pressable } from 'native-base';
import React from 'react';

import { TableContent } from '../../../../../../../../../components/TableContent';
import { LateralBar } from '../../../../../../../../BatchTicket/components/DynamicAsset/components/Asset/components/LateralBar';
import { usePublicOfferAssetContext } from '../../../../../../../../BatchTicket/components/DynamicAsset/contexts/products/PublicOffer';
import { useGlobalProductContext } from '../../../../../contexts';

import { PublicOfferItemTypes } from '.';

export const PublicOfferItemTablet: React.FC<PublicOfferItemTypes.Props> = ({ offer }) => {
  const { setModalOpen, setOfferSelected } = usePublicOfferAssetContext();
  const { product } = useGlobalProductContext();

  const onOpenDetailsModal = () => {
    setModalOpen(true);
    setOfferSelected(offer);
  };

  const topInfos = [
    {
      label: 'Tipo Oferta',
      value: (
        <HStack space={Spacing['inline.quarck']} alignItems="center">
          <Pressable onPress={onOpenDetailsModal}>
            <UI.Icon name="Info" size="xs" />
          </Pressable>
          <UI.Text color="neutral.dark">{offer.offerType}</UI.Text>
        </HStack>
      ),
      maxW: '24%',
    },
    {
      label: 'Nome',
      value: <UI.Text color="neutral.dark">{offer.offerName}</UI.Text>,
      maxW: '24%',
    },
    {
      label: 'Cód. Isin',
      value: <UI.Text color="neutral.dark">{offer.isinCode}</UI.Text>,
      maxW: '24%',
    },
    {
      label: 'Alteração',
      value: <UI.Text color="neutral.dark">{offer.alterationDateFormatted}</UI.Text>,
      maxW: '24%',
    },
  ];

  const bottomInfos = [
    {
      label: 'Negociação',
      value: <UI.Text color="neutral.dark">{offer.negotiationDateFormatted}</UI.Text>,
      maxW: '24%',
    },
    {
      label: 'Liquidação',
      value: <UI.Text color="neutral.dark">{offer.liquidityDateFormatted}</UI.Text>,
      maxW: '24%',
    },
    {
      label: 'Perfil',
      value: <UI.Text color="neutral.dark">{offer.suitabilityProfile}</UI.Text>,
      maxW: '24%',
    },
    {
      label: 'Limitador',
      value: <UI.Text color="neutral.dark">{offer.rateLimiterTranslated}</UI.Text>,
      maxW: '24%',
    },
  ];

  return (
    <TableContent direction="row" space={0} p={0} px={Spacing['inline.xxxs']}>
      <LateralBar
        backgroundColor={product.color}
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      <VStack padding={Spacing['inset.sm']} space={Spacing['stack.xxxs']} w="full">
        <HStack justifyContent="space-between" alignItems="start">
          {topInfos.map(({ label, value, maxW }) => (
            <VStack maxW={maxW} w={maxW} space={Spacing['stack.quarck']} key={label}>
              <UI.Text color="neutral.black" variant="semibold">
                {label}
              </UI.Text>
              {value}
            </VStack>
          ))}
        </HStack>
        <HStack justifyContent="space-between">
          {bottomInfos.map(({ label, value, maxW }) => (
            <VStack maxW={maxW} w={maxW} space={Spacing['stack.quarck']} key={label}>
              <UI.Text color="neutral.black" variant="semibold">
                {label}
              </UI.Text>
              {value}
            </VStack>
          ))}
        </HStack>
      </VStack>
    </TableContent>
  );
};
